export const TooltipCtrlModel = function (data) {
    if (!data) data = {};
    this.type = data.type || "";
    this.msg = data.msg || null;
    this.tooltipHtml = data.tooltipHtml || null;
    this.enableForceShow = data.enableForceShow || false;
};